<template>
  <div class="hero">
    <div class="hero--content">
      <p class="title">Hi, I'm Dan.</p>
      <p>A freelance web developer with over a decade of studio experience under my belt, a keen interest in all things digital and a passion for problem solving.</p>
      <p>I have a wide range of development experience, with a skill set spanning CMS to eCommerce websites, interactive installations to App development.</p>
      <p>I'm currently seeking new opportunites so if you'd like to chat, drop me an email on <span class="link">hello[at]daniellong.co.uk</span> or <a class="link" href="/Dan-Long-CV.pdf" download>check out my CV</a>.</p>
    </div>

    <img class="arrow" src="@/assets/images/down-arrow.svg" alt="Arrow to prompt user to scroll down" aria-label="hidden" />

  </div>
</template>

<script>
export default {
  name: 'Hero',
}
</script>

<style lang="scss">

</style>
